import { Component, Input, ViewChild, ElementRef, OnChanges, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CourseService } from '@app/_services/course.service';
import { first } from 'rxjs/operators';

@Component({ selector: 'audio-transcript', templateUrl: 'audio-transcript.component.html' })
export class AudioTranscriptComponent implements OnChanges {
    @ViewChild('audioPlayer') audioPlayer: ElementRef<HTMLAudioElement>;
    @ViewChild('audioPlayerToggler') toggler: ElementRef<HTMLDivElement>;
    @Input() source: string;
    @Input() transcript: string;


    // ngOnInit() {
    //     window.addEventListener('scroll', this.scroll, true); //third parameter
    // }

    // ngOnDestroy() {
    //     window.removeEventListener('scroll', this.scroll, true);
    // }

    // scroll = (event): void => {
    //     let scrollTop = event.target.scrollingElement.scrollTop;
    //     if (scrollTop > 700) {
    //         debugger;
    //         this.toggler.nativeElement.style.position = 'absolute';
    //         this.toggler.nativeElement.style.top = scrollTop;
    //     } else {
    //         this.toggler.nativeElement.style.position = 'fixed';
    //     }
    // };

    togglePlayer() {
        if (this.audioPlayer.nativeElement.paused) {
            this.audioPlayer.nativeElement.play();
            this.toggler.nativeElement.classList.remove('paused');
            this.toggler.nativeElement.classList.add('playing');
        }
        else {
            this.audioPlayer.nativeElement.pause();
            this.toggler.nativeElement.classList.add('paused');
            this.toggler.nativeElement.classList.remove('playing');
        }
    }

    ngOnDestroy() {
        this.audioPlayer.nativeElement.pause();
        this.toggler.nativeElement.classList.add('paused');
        this.toggler.nativeElement.classList.remove('playing');
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.source && this.audioPlayer) {
            this.audioPlayer.nativeElement.pause();
            this.toggler.nativeElement.classList.add('paused');
            this.toggler.nativeElement.classList.remove('playing');
        }
    }

    ended() {
        this.toggler.nativeElement.classList.add('paused');
        this.toggler.nativeElement.classList.remove('playing');
    }
}